import React from "react";
import NewsSection from "../../components/Media/News.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
// import PartnerWithAptechSection from "../components/PartnerWithAptech/PartnerWithAptech.tsx";
const News = () => {
  return (
    <div>
       <MetaComponent
        title="Aptech in News – Aptech Limited."
        desc="Aptech Limited is a global leader in vocational education and training. Check out the latest news and insights on this pioneering education institute here."
        keywords="vocational training, aptech news, aptech insights."
      />
      <NewsSection />
    </div>
  );
};

export default News;
